import React from "react";
import { StandardDrawerHeader } from "./StandardDrawer";

function TopTitleFormComponent(props) {
  return (
    <StandardDrawerHeader
      eyebrow={props.eyebrow}
      title={props.title}
      subtitle={props.subtitle}
      onClose={props.closemodal}
    />
  );
}

export default TopTitleFormComponent;
